/**
 * @generated SignedSource<<1ccda06739851bf26cdc6b50840c2a45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignupConfirmMutationInput = {
  clientMutationId?: string | null;
  code: string;
  token: string;
};
export type AuthSnsSignupConfirmMutation$variables = {
  input: SignupConfirmMutationInput;
};
export type AuthSnsSignupConfirmMutation$data = {
  readonly signupConfirm: {
    readonly __typename: "SignupConfirmError";
    readonly message: string;
  } | {
    readonly __typename: "SignupConfirmSuccess";
    readonly refreshToken: string;
    readonly token: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AuthSnsSignupConfirmMutation = {
  response: AuthSnsSignupConfirmMutation$data;
  variables: AuthSnsSignupConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "signupConfirm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refreshToken",
            "storageKey": null
          }
        ],
        "type": "SignupConfirmSuccess",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "SignupConfirmError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSnsSignupConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthSnsSignupConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31ca8e3cc51126bae9953d132f168d7f",
    "id": null,
    "metadata": {},
    "name": "AuthSnsSignupConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation AuthSnsSignupConfirmMutation(\n  $input: SignupConfirmMutationInput!\n) {\n  signupConfirm(input: $input) {\n    __typename\n    ... on SignupConfirmSuccess {\n      token\n      refreshToken\n    }\n    ... on SignupConfirmError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb12f240e5b995f92e16319e185b8b43";

export default node;
